import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {IHistoryState, IItem} from "./types";
import {fetchHistory} from "./asyncActions";

const initialState: IHistoryState = {
    items: [],
    isLoading: false
}

const GetCards = createSlice({
  name: "getCards",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHistory.pending, (state) => {
        state.isLoading = true;
    })
    builder.addCase(
        fetchHistory.fulfilled,
        (state, action: PayloadAction<IItem[]>) => {
            state.items = action.payload
            state.isLoading = false;
        }
    );
    builder.addCase(fetchHistory.rejected, (state) => {
        state.items = [];
        state.isLoading = false;
    });
  },
});

export default GetCards.reducer;

